module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_5.e49f4548.png";